export const CONTROL_PROGRAM_STATES = {
    ACTIVE: "active",
    INACTIVE: "inactive",
    DELETED: "deleted",
} as const;

export type ControlProgramState =
    (typeof CONTROL_PROGRAM_STATES)[keyof typeof CONTROL_PROGRAM_STATES];

/**
 * @param controlProgram `undefined` when the id did not resolve, i.e. the
 * program was deleted.
 */
export function toControlProgramState(
    controlProgram: { running: boolean } | undefined
): ControlProgramState {
    if (!controlProgram) {
        return CONTROL_PROGRAM_STATES.DELETED;
    }
    return controlProgram.running
        ? CONTROL_PROGRAM_STATES.ACTIVE
        : CONTROL_PROGRAM_STATES.INACTIVE;
}
